import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Routes } from "./infrastructure/routes";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import intializeAxios from "./infrastructure/http/Axios";
import { persistor, store } from "./domain/store/configureStore";

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <Routes />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
intializeAxios();
